import React, { forwardRef, ForwardRefRenderFunction } from 'react';
// import { useController } from 'react-hook-form';
import { TextInput as TextInputRN } from 'react-native';
import { TextInput, TextInputProps, HelperText } from 'react-native-paper';
import { themes } from '../../design/colors';
import MaskInput, { Masks } from 'react-native-mask-input';

interface TextFieldProps extends TextInputProps {
  mode?: "outlined" | "flat";
  label?: any;
  placeholder?: string;
  secureTextEntry?: boolean;
  value: string;
  onChangeText: any;
  mask?: 'cpf' | 'date' | 'short-date' | 'cel-phone' | 'zip-code' | 'credit-card' | 'cnpj' | 'american-express-card' | 'diners-club-card';
}

/**
 * Componente: TextField
 * - `name`: props para identificação pro backend
 * - `control`: props para o react hook form
 * - `supportingText`: props para o texto de suporte do input
 * - `hasSupportingText`: props para exibir o texto de suporte do input
 * - `mask`: props que define o tipo de máscara
 * **/
const TextFieldComponent: ForwardRefRenderFunction<TextInputRN,TextFieldProps> = (
  { mode = "outlined", label, placeholder, secureTextEntry, value, onChangeText, mask, ...rest }: TextFieldProps,
  ref
) => {
  const CNPJ_MASK = [/\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "/", /\d/, /\d/, /\d/, "-", /\d/, /\d/];

  function selectMask() {
    switch (mask) {
      case 'cpf':
        return Masks.BRL_CPF;
      case 'date':
        return Masks.DATE_DDMMYYYY;
      case 'cel-phone':
        return Masks.BRL_PHONE;
      case 'zip-code':
        return Masks.ZIP_CODE;
      case 'credit-card':
        return Masks.CREDIT_CARD;
      case 'cnpj':
        return CNPJ_MASK;
      default:
        return null;
    }
  }

  return (
    <>
      {mask ? (
        <TextInput
          {...rest}
          mode="outlined"
          label={label}
          placeholder={placeholder}
          secureTextEntry={secureTextEntry}
          value={value}
          onChangeText={(text) => onChangeText(text)}
          style={{ marginBottom: 19 }}
          render={(props) => <MaskInput {...props} mask={selectMask()} />}
          theme={{
            colors: {
              text: themes.colors.black,
              background: themes.colors.white,
              primary: themes.colors.black,
              disabled: themes.colors.disabled,
              placeholder: themes.colors.black,
            },
            roundness: 8,
          }}
        />
      ) : (
        <TextInput
          {...rest}
          mode="outlined"
          label={label}
          placeholder={placeholder}
          secureTextEntry={secureTextEntry}
          value={value}
          onChangeText={(text) => onChangeText(text)}
          style={{ marginBottom: 19 }}
          theme={{
            colors: {
              text: themes.colors.black,
              background: themes.colors.white,
              primary: themes.colors.black,
              disabled: themes.colors.disabled,
              placeholder: themes.colors.black,
            },
            roundness: 8,
          }}
        />
      )}
    </>
  );
};

export const TextField = forwardRef(TextFieldComponent);
